import { put, takeEvery } from 'redux-saga/effects';
import * as types from './types';

function* addEvents(action) {
  yield put({ type: types.ADD_EVENTS, events: action.payload });
};

function* updateEvent(action) {
  yield put({ type: types.UPDATE_EVENT, payload: action.payload });
};

function* removeEvent(action) {
  yield put({ type: types.REMOVE_EVENT, payload: action.payload });
}

export default function* watchEvents() {
  yield takeEvery(types.ADD_EVENTS_SUCCESS, addEvents);
  yield takeEvery(types.UPDATE_EVENT_SUCCESS, updateEvent);
  yield takeEvery(types.REMOVE_EVENT_SUCCESS, removeEvent);
};
